/**
 * Tab IDs for the main application tabs
 */
export const TAB_IDS = {
  context: 'context',
  transcript: 'transcript',
  document: 'document',
  contest: 'contest',
} as const;
